<template>
    <component :is="mask ? 'the-mask' : 'input'"
      :name="name"
      :value="value"
      class="emd-input"
      :class="[
        size && `_size_${size}`,
        classList
      ]"
      :minlength="minLength"
      :maxlength="maxLength"
      :id="name"
      :type="type"
      :required="required"
      :autofocus="autoFocus"
      :mask="mask"
      @input="handleInput"
      @keyup="handleKeyUp"
      :placeholder="placeholder"
      :disabled="disabled"
      :data-cy="dataCy"
    />
</template>

<script>
import { TheMask } from 'vue-the-mask'

export default {
  name: 'EmdInput',
  components: { TheMask },
  props: {
    value: {
      required: true
    },
    mask: {
      type: [String, Array],
      required: false
    },
    name: {
      required: true,
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    minLength: {
      type: Number
    },
    maxLength: {
      type: Number
    },
    placeholder: {
      type: String,
      required: false
    },
    classList: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false,
      validator: function (value) {
        return ['small', 'big'].indexOf(value) !== -1
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onInput: {
      type: Function,
      default: () => {}
    },
    dataCy: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    handleInput (e) {
      const value = e.target ? e.target.value : e
      this.$emit('input', value)
      this.onInput(e)
    },
    handleKeyUp (e) {
      this.$emit('keyup', e)
    }
  }
}
</script>
